import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import { IoEllipse } from 'react-icons/io5';
import { RiArrowDropDownLine } from 'react-icons/ri';
import { FaAngleRight } from 'react-icons/fa6';
import languageList from '@constants/languageList';
import { FaAngleDown } from 'react-icons/fa';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getDataUsingUserId } from '@utils/sharedUtils';
import { USER_INFO_TABLE } from '@constants/dynamoDBTableName';
import { formattedDateTime, updateUser } from '@utils/utils';
import { setLanguage } from '@store/reducers/auth/loginSlice';

const Setting: React.FC = () => {
    const [isScheduled, setIsScheduled] = useState(false);
    const [isAlertNotification, setIsAlertNotification] = useState(false);
    const loggedInUserID = useAppSelector((state) => state.login.loggedInUserID);
    const CurrentLanguage = useAppSelector((state) => state.login.language);
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();

    const [selectedLang, setSelectedLang] = useState(
        CurrentLanguage !== '' ? CurrentLanguage.toLowerCase() : 'en'
      );
  
      // sortedLanguages always puts the selected language first
      const sortedLanguages = useMemo(() => {
        return [
          ...languageList.filter(lang => lang.code.toLowerCase() === selectedLang),
          ...languageList.filter(lang => lang.code.toLowerCase() !== selectedLang),
        ];
      }, [selectedLang]);

      useEffect(() => {
        if (CurrentLanguage && CurrentLanguage.toLowerCase() !== selectedLang) {
          setSelectedLang(CurrentLanguage.toLowerCase());
        }
      }, [CurrentLanguage, sortedLanguages]);
    const ToggleOnSVG = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="20"
            viewBox="0 0 40 20"
            fill="none"
        >
            <rect width="40" height="20" rx="10" fill="#0346A2" />
            <circle
                cx="29"
                cy="10"
                r="7.74286"
                fill="white"
                stroke="url(#paint0_linear_1690_2460)"
                strokeWidth="0.514286"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1690_2460"
                    x1="21"
                    y1="2"
                    x2="21"
                    y2="18"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8F8F8" stopOpacity="0.0252353" />
                    <stop offset="1" stopColor="#EEEEEE" />
                </linearGradient>
            </defs>
        </svg>
    );

    const ToggleOffSVG = () => (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="20"
            viewBox="0 0 40 20"
            fill="none"
        >
            <rect width="40" height="20" rx="10" fill="#D1D5DB" />
            <circle
                cx="11"
                cy="10"
                r="7.74286"
                fill="white"
                stroke="url(#paint0_linear_1690_2460)"
                strokeWidth="0.514286"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1690_2460"
                    x1="3"
                    y1="2"
                    x2="3"
                    y2="18"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#F8F8F8" stopOpacity="0.0252353" />
                    <stop offset="1" stopColor="#EEEEEE" />
                </linearGradient>
            </defs>
        </svg>
    );
    const onBackClick = () => {
        navigate(-1);
    };
    const handleScheduleToggle = () => {
        setIsScheduled(!isScheduled);
    };
    const handleAlertToggle = () => {
        setIsAlertNotification(!isAlertNotification);
    };
    const { i18n } = useTranslation();

    const changeLanguage = (language: string) => {
        // dispatch(setLanguage(language.toLowerCase()));
        setSelectedLang(language.toLowerCase());
        localStorage.setItem('appLanguage', language.toLowerCase());
        i18n.changeLanguage(language);
        window.location.reload();
    };

    const handleLanguageChange = async (
        event: React.ChangeEvent<HTMLSelectElement>
    ) => {
        const selectedCountry = event.target.value;
        let userInfoData = await getDataUsingUserId(
                                USER_INFO_TABLE,
                                loggedInUserID
                            );
        
        if(userInfoData && userInfoData.Items && userInfoData.Items?.length != 0) {
            let userInfoId = userInfoData.Items[0];

            let attributeNames = {
                '#language': 'language',
                '#modified_by': 'modified_by',
                '#modified_at': 'modified_at'
            };
    
            let attributeValues = {
            ':language': { S: selectedCountry.toLowerCase() },
            ':modified_by': { S: loggedInUserID },
            ':modified_at': { S: formattedDateTime },
            };
        
            let updateExpression =
            'SET #language = :language, #modified_by = :modified_by, #modified_at = :modified_at';
    
            if(userInfoId?.uuid?.S) {
                await updateUser(USER_INFO_TABLE, userInfoId?.uuid?.S, attributeNames, attributeValues, updateExpression);
            }
        }
        changeLanguage(selectedCountry.toLowerCase());
    };

    return (
        <div>
            <div className="font-bold text-base text-black">
                <div
                    className="flex items-center cursor-pointer"
                    onClick={onBackClick}
                >
                    <FaArrowLeftLong className="cursor-pointer" />{' '}
                    <h5 className="font-semibold ml-2">
                        {t('settings.back')}
                    </h5>
                </div>
            </div>
            <div className="cart relative mx-auto bg-white rounded-2xl p-5 mt-5 w-[420px]">
                {/* <span className="!my-3 text-text_gray_clr font-semibold text-base">
                    {t('settings.notification_setting')}{' '}
                </span>
                <div className="my-1 flex  items-center justify-between">
                    <label
                        className="block mb-2 font-semibold text-base text-black"
                        htmlFor="scheduleToggle"
                    >
                        {t('settings.scheduling_later')}
                    </label>
                    <div
                        onClick={handleScheduleToggle}
                        className="cursor-pointer"
                    >
                        {!isScheduled ? <ToggleOnSVG /> : <ToggleOffSVG />}
                    </div>
                </div> */}
                {/* <div className="mb-1 flex  items-center justify-between">
                    <label
                        className="block mb-2 font-semibold text-base text-black"
                        htmlFor="scheduleToggle"
                    >
                        {t('settings.alert_notification')}
                    </label>
                    <div onClick={handleAlertToggle} className="cursor-pointer">
                        {!isAlertNotification ? (
                            <ToggleOnSVG />
                        ) : (
                            <ToggleOffSVG />
                        )}
                    </div>
                </div> */}
                {/* <div className="mb-1 flex  items-center justify-between"> */}
                    {/* <label
                        className="block mb-2 font-semibold text-base text-black"
                        htmlFor="scheduleToggle"
                    >
                        {t('settings.notification_sound')}
                    </label> */}
                    {/* <div onClick={handleToggle} className="cursor-pointer">
                        {!isScheduled ? <ToggleOnSVG /> : <ToggleOffSVG />}
                    </div> */}
                    {/* <span className="text-xs text-primary ml-28">
                        {t('settings.happy_pop...')}
                    </span> */}
                    {/* <select
                        defaultValue="happy_pop"
                        aria-label="sound"
                        className="appearance-none w-[46%] bg-white text-primary px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline"
                        // onChange={handleLanguageChange}
                    >
                        <option value="happy_pop">happy_pop....</option>
                    </select> */}
                    {/* <div className="pointer-events-none absolute top-[28px] bottom-0 right-[48px] flex items-center px-2 text-gary cursor-pointer">
                        <FaAngleDown className="font-white" />
                    </div> */}
                    {/* <button className="flex items-center relative">
                        <IoEllipse
                            size={20}
                            className="absolute text-ellips_clr"
                        />
                        <RiArrowDropDownLine
                            size={18}
                            className="relative left-0.5"
                        />
                    </button> */}
                {/* </div> */}
                <span className="!my-3 text-text_gray_clr font-semibold text-base">
                    {' '}
                    {t('settings.general_setting')}{' '}
                </span>
                <div className="my-1 flex  items-center justify-between">
                    <label
                        className="block mb-2 font-semibold text-base text-black"
                        htmlFor="scheduleToggle"
                    >
                        {t('settings.language')}
                    </label>
                    {/* <span className='text-xs text-primary -mr-48'>
                    {t('settings.english')} 
                    </span>
                    <button className='flex items-center relative'>
                        <IoEllipse size={20} className='absolute text-ellips_clr'  />
                        <RiArrowDropDownLine size={18} className='relative left-0.5' />
                    </button> */}
                    <div className="relative inline-block text-left">
                        <select
                            defaultValue={selectedLang}
                            aria-label="language"
                            className="appearance-none w-full bg-white text-primary px-4 py-2 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline"
                            onChange={handleLanguageChange}
                        >
                            {sortedLanguages.map((language, index) => (
                                <option key={index} value={language.code}>
                                    {language.name}
                                </option>
                            ))}
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gary cursor-pointer">
                            <FaAngleDown className="font-white" />
                        </div>
                    </div>
                </div>
                {/* <button className='flex items-center relative  left-[22rem] top-12'>
                        <IoEllipse size={20} className='absolute text-ellips_clr'  />
                        <FaAngleRight size={10} className='relative left-1.5' />
                    </button> */}
            </div>
        </div>
    );
};
export default Setting;
